import { countdownLabel, dayNum, monLong, whenLine, yearOf } from "../lib/format.js";
import AddToCalendar from "./AddToCalendar.jsx";

export default function Hero({ settings, next, stats }) {
  const showCard = settings.showNextEventCard !== false;

  return (
    <section className="hero" id="top">
      <div className="wrap hero-grid">
        <div>
          <p className="eyebrow eyebrow-dot">
            Netzwerk für Startups &amp; Jungunternehmer · {settings.region} · seit {settings.founded}
          </p>
          <h1>{settings.headline}</h1>
          <p className="hero-lead">{settings.claim}</p>

          <div className="hero-cta">
            <a className="btn" href="#mitmachen">
              Firma anmelden
            </a>
            <a className="btn btn-ghost" href="#anlaesse">
              Anlässe ansehen
            </a>
          </div>
          <p className="hero-micro">
            Kein Mitgliederbeitrag im ersten Jahr. Der erste Besuch ist unverbindlich.
          </p>

          <div className="stats">
            <div>
              <b>{stats.members}</b>
              <span>Firmen im Netzwerk</span>
            </div>
            <div>
              <b>{stats.branches}</b>
              <span>Branchen</span>
            </div>
            <div>
              <b>{settings.eventsPerYear}</b>
              <span>Anlässe pro Jahr</span>
            </div>
          </div>
        </div>

        {showCard ? (
          <div className="next">
            <div className="next-top">
              <span className="label-mono">Nächster Anlass</span>
              {next ? <span className="pill">{countdownLabel(next.date)}</span> : null}
            </div>
            <div className="next-body">
              {next ? (
                <>
                  <div className="next-date">
                    <b>{dayNum(next.date)}</b>
                    <span>
                      {monLong(next.date)} {yearOf(next.date)}
                    </span>
                  </div>
                  <h3>{next.title}</h3>
                  <div className="next-meta">
                    <div>{whenLine(next)}</div>
                    {next.location ? <div>{next.location}</div> : null}
                    {next.host ? (
                      <div>
                        <span>Gastgeber:</span> {next.host}
                      </div>
                    ) : null}
                  </div>
                  <div className="next-actions">
                    <a className="btn btn-ghost btn-sm" href="#anlaesse">
                      Alle Anlässe
                    </a>
                    <AddToCalendar ev={next} />
                  </div>
                </>
              ) : (
                <>
                  <h3>Der nächste Termin wird gerade abgestimmt.</h3>
                  <div className="next-meta">
                    Trag dich in der LinkedIn-Gruppe ein, dann bekommst du die Einladung zuerst.
                  </div>
                </>
              )}
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}
